import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface homeState {
  eventList: [];
  socialImpact: {
    csrUser: any;
    hours: any;
    events: any;
  };
}

const initialState: homeState = {
  eventList: [],
  socialImpact: {
    csrUser: 0,
    hours: 0,
    events: 0,
  },
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.eventList = action.payload;
      })

      .addCase(socialImpactCount.fulfilled, (state, action) => {
        state.socialImpact = action.payload;
      });
  },
});

export default homeSlice.reducer;

export const fetchPosts = createAsyncThunk("posts/fetchPosts", async () => {
  const response = await axiosInstance.get(`/api/events/getAllEvents`);
  return response.data;
});

export const socialImpactCount = createAsyncThunk(
  "events/eventStats",
  async () => {
    const response = await axiosInstance.get(`/api/events/eventStats`);
    return response.data;
  }
);
